import { SkeletonButton } from '@pixum/skeleton';

/**
 * Loading skeleton for proceed button
 *
 * Shows disabled button placeholder while data streams in.
 * Also shown when no articles in cart or on data fetch errors.
 */
export function ProceedButtonSkeleton() {
  return <SkeletonButton />;
}
